import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldOff, Trash2 } from "lucide-react";

export default function ModerationCard({ channelUsername }) {
  const [bans, setBans] = useState([]);
  const [banUsername, setBanUsername] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = () => {
    api.get(`/channels/${channelUsername}/bans`).then(r => setBans(r.data)).catch(() => setBans([]));
  };
  useEffect(() => { if (channelUsername) load(); }, [channelUsername]); // eslint-disable-line react-hooks/exhaustive-deps

  const banNow = async (e) => {
    e.preventDefault();
    if (!banUsername.trim()) return;
    setBusy(true); setErr("");
    try {
      await api.post(`/channels/${channelUsername}/ban`, { username: banUsername.trim(), reason });
      setBanUsername(""); setReason("");
      load();
    } catch (e2) { setErr(e2?.response?.data?.detail || "Ban failed"); }
    finally { setBusy(false); }
  };

  const unban = async (u) => {
    try { await api.delete(`/channels/${channelUsername}/ban/${u}`); load(); } catch { /* */ }
  };

  return (
    <div className="sc-card p-6 space-y-4">
      <div className="flex items-center gap-2">
        <ShieldOff className="w-5 h-5 text-[color:var(--sc-pink)]" />
        <div className="sc-heading text-xl font-bold">Channel Moderation</div>
      </div>
      <p className="text-xs text-zinc-400">Ban users from your channel (they can't rejoin or chat). To kick temporarily, click a user in chat.</p>

      <form onSubmit={banNow} className="grid sm:grid-cols-5 gap-2">
        <input data-testid="mod-ban-username" value={banUsername} onChange={e => setBanUsername(e.target.value)} placeholder="Username" className="sc-input text-sm sm:col-span-2" />
        <input data-testid="mod-ban-reason" value={reason} onChange={e => setReason(e.target.value)} placeholder="Reason (optional)" className="sc-input text-sm sm:col-span-2" />
        <button data-testid="mod-ban-submit" disabled={busy} className="sc-btn text-xs">Ban</button>
      </form>
      {err && <div className="text-[#FF1053] text-xs">{err}</div>}

      <div>
        <div className="sc-label mb-2">Banned ({bans.length})</div>
        {bans.length === 0 && <div className="text-xs text-zinc-500 py-2">No bans on this channel.</div>}
        {bans.map(b => (
          <div key={b.banned_user_id} className="flex items-center justify-between p-2 border border-white/10 rounded-sm mb-2">
            <div>
              <div className="text-sm font-semibold">{b.banned_username}</div>
              {b.reason && <div className="text-[10px] text-zinc-500">"{b.reason}"</div>}
            </div>
            <button data-testid={`mod-unban-${b.banned_username}`} onClick={() => unban(b.banned_username)} className="sc-btn-ghost text-xs flex items-center gap-1"><Trash2 className="w-3 h-3" /> Unban</button>
          </div>
        ))}
      </div>
    </div>
  );
}
